import React, { createRef } from "react";
import PrincipaleMobile from './PrincipaleMobile';
import PrincipaleDefault from './PrincipaleDefault';
import { mediaStyles, MediaContextProvider, Media } from "../../core";

export default class Principale extends React.Component {
    contextRef = createRef();

    render() {
        // il div è utilizzato perche il container fluid, in versione mobile, lascia dello spazio a destra e sinistra nel menu
        return (
            <div>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThan="mobile">
                        <PrincipaleDefault />
                    </Media>
                    <Media at="mobile">
                        <PrincipaleMobile />
                    </Media>                
                </MediaContextProvider>
            </div>
        );
    }
}
